export { default } from './PopupTitle';
//# sourceMappingURL=index.js.map